module.exports = __webpack_public_path__ + "img/team-1-1-modal.420c6045.jpg";